import types from '../types/summary'
import {RENT, TRANSACTIONS} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import {endpoint as endpointText} from '../../../common/text'
import {push} from 'react-router-redux'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

let commentTimer = null

export default class summary {

  static selectCard(card) {
    return {
      type: types.SELECT_CARD,
      payload: {
        card,
      },
    }
  }

  static setComment(value) {
    return function(dispatch) {

      dispatch({
        type: types.SET_COMMENT,
        payload: {
          value,
        },
      })

      clearTimeout(commentTimer)
      commentTimer = setTimeout(() => {
        dispatch(summary.modifyRent())
      }, 1000)
    }
  }

  static fetchRentCosts() {
    return function(dispatch, getState) {

      dispatch({type: types.FETCH_RENT_COSTS})

      const deliveryID = getState().ui.rentV2.start.getIn(['rent', 'Delivery']).ID
      const pickupID = getState().ui.rentV2.start.getIn(['rent', 'Pickup']).ID

      return Promise.all([
        apiPrivate.get(TRANSACTIONS + '/transactions/price/' + deliveryID),
        apiPrivate.get(TRANSACTIONS + '/transactions/price/' + pickupID),
      ])
        .then(results => {
          const deliveryCost = results[0].data.description
          const pickupCost = results[1].data.description

          dispatch(summary.fetchRentCostsSuccess(deliveryCost, pickupCost))
          return true
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(summary.fetchRentCostsFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(summary.fetchRentCostsFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static fetchRentCostsSuccess(deliveryCost, pickupCost) {
    return {
      type: types.FETCH_RENT_COSTS_SUCCESS,
      payload: {
        deliveryCost,
        pickupCost,
      },
    }
  }

  static fetchRentCostsFail(error) {
    return {
      type: types.FETCH_RENT_COSTS_FAIL,
      payload: {
        error,
      },
    }
  }

  static modifyRent() {
    return function(dispatch, getState) {

      const state = getState().ui.rentV2.summary

      const rent = getState().ui.rentV2.start.getIn(['rent', 'ID'])
      const comment = state.get('comment')
      const card = state.get('card')

      dispatch({type: types.MODIFY_RENT})

      const data = new FormData()
      if (comment !== '') data.append('comments', comment)
      data.append('card_id', card)

      return apiPrivate.put(RENT + '/rent/' + rent, data)
        .then(response => {
          dispatch(summary.modifyRentSuccess())
          return true
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(summary.modifyRentFail(message))
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(summary.modifyRentFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
          return false
        })
    }
  }

  static modifyRentSuccess() {
    return {
      type: types.MODIFY_RENT_SUCCESS,
    }
  }

  static modifyRentFail(error) {
    return {
      type: types.MODIFY_RENT_FAIL,
      payload: {
        error,
      },
    }
  }

  static confirm() {
    return function(dispatch, getState) {

      const rentID = getState().ui.rentV2.start.getIn(['rent', 'ID'])

      dispatch({type: types.CONFIRM})

      return apiPrivate.put(RENT + '/rent/' + rentID + '/confirm')
        .then(response => {
          dispatch(summary.confirmSuccess())
          return true
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(summary.confirmFail(message))
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(summary.confirmFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
          return false
        })
    }
  }

  static confirmSuccess() {
    return {
      type: types.CONFIRM_SUCCESS,
    }
  }

  static confirmFail(error) {
    return {
      type: types.CONFIRM_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/rentV2/actions/summary.js